export default {
    loaded: ({popups}) => popups.loaded,
    popups: ({popups}) => popups.popups
}